import { Currency } from '@mr-yum/frontend-core/dist/services/createDinero'

import {
  BasicInvoicePartsFragment,
  LineItemPartsFragment,
  StaffInvoicePartsFragment,
  UserInvoicePartsFragment,
} from '@/gql/graphql'

export interface Company {
  name: string
  regNum: string
  email: string
  taxName: string
}
export enum InvoiceType {
  BasicInvoice = 'basic',
  MultiVendorOrder = 'multi_vendor_order',
}
export interface InvoiceProps {
  invoice?: StaffInvoicePartsFragment | Partial<BasicInvoicePartsFragment>
  items: LineItemPartsFragment[]
  groupedItems: GroupedLineItemsProps[]
  user?: UserInvoicePartsFragment | null
  totalTaxInCents: number
  totalInCents: number
  hasNotes?: boolean
  invoiceType?: InvoiceType
}

export interface OrderItemsProps {
  lineItems: LineItemPartsFragment[]
  currency: Currency
}

export interface LineItemsProps {
  lineItems: Required<LineItemPartsFragment[]>
  parentId?: string | null
  currency: Currency
}

export interface GroupedLineItemsProps {
  groupTitle?: string
  menuItems: LineItemPartsFragment[]
  additionalItems: LineItemPartsFragment[]
  groupSlug?: string
  orderId?: string
}
